import { Component, Inject, Input } from "@angular/core";

import { Shop } from "@hermes/api-model-shop";
import { LOCALE } from "@hermes/app-core";
import { Locale, LocaleCode } from "@hermes/locale";

export type AddressType = "us" | "jp" | "my_sg" | "mx" | "generic";

export const ADDRESS_TYPE_MAPPING: Partial<Record<LocaleCode, AddressType>> = {
    ["us_en"]: "us",
    ["jp_ja"]: "jp",
    ["my_en"]: "my_sg",
    ["sg_en"]: "my_sg",
    ["mx_es"]: "mx",
};

@Component({
    selector: "h-shop-address",
    templateUrl: "./shop-address.component.html",
    styleUrls: ["./shop-address.component.scss"],
    standalone: false,
})
export class ShopAddressComponent {
    @Input()
    public shop!: Shop;

    public addressType: AddressType =
        ADDRESS_TYPE_MAPPING[this.locale.code] ?? "generic";

    constructor(@Inject(LOCALE) private locale: Locale) {}
}
